/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSimulationWarrantiesGroupProtectionMutation($input: SaveSimulationWarrantiesGroupProtection_M_simulation_warranties_group_protectionInput!) {
    saveSimulationWarrantiesGroupProtection_M_simulation_warranties_group_protection(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
